// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'layout';

export const Component = () => (
  <path d='M22.116 2H3.486c-.432 0-.767.144-1.055.431A1.408 1.408 0 0 0 2 3.485V21.11c0 .432.144.767.431 1.054.288.288.623.432 1.054.432h18.63a1.41 1.41 0 0 0 1.055-.432c.287-.287.43-.622.43-1.054V3.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 22.116 2Zm.527 1.485V21.11c0 .336-.191.527-.527.527H3.486c-.335 0-.479-.191-.479-.527V3.485c0-.335.144-.526.479-.526h18.63c.336 0 .527.191.527.526ZM5.928 4.922v3.927h13.745V4.922H5.928Zm1.006 2.97V5.927h11.78V7.89H6.935Zm0 2.92v8.86h4.885v-8.86H6.934Zm.957 7.855V11.82h2.97v6.848H7.89Zm5.892-7.855v6.897h4.933v-6.896h-4.933Zm1.005 5.891v-4.885h2.921v4.885h-2.92Z' />
);

export const viewBox = '0 0 25 25';
